<template>
  <el-dialog :title="title" class="dialog-cache" z-index="990" :visible.sync="dialogAnalysisVisible" :close-on-press-escape="false" :close-on-click-modal="false" width="90vw" top="5vh">
    <MeterNoteAnalysis :master_id="analysis_meter_id" v-if="dialogAnalysisVisible" />
  </el-dialog>
</template>

<script>

import MeterNoteAnalysis from "./MeterNoteAnalysis";
export default {
  name: "MeterNoteAnalysisWindow",
  inject:['mainObj','componentId','setComponentId'],
  components: {MeterNoteAnalysis},
  data(){
    return{
      dialogAnalysisVisible:false,
      analysis_meter_id:0,
      title:"",
    }
  },
  methods:{
    show(meter_id,title=''){
      this.title=(title+"_仪表分析")
      this.analysis_meter_id=meter_id;
      this.dialogAnalysisVisible=true;
    }
  },
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_note/components/MeterNoteAnalysisWindow.vue